/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Flex } from '@radix-ui/themes';

import { styled } from 'fierry/react';

import Text from 'solis/react/primitive/text';


const getCurrent = ({ colony }) =>
{
  return colony.cass.currentInfluence;
};


const getRemaining = ({ colony, influenceDelta }) =>
{
  return colony.cass.currentInfluence - influenceDelta;
};


const getTotal = ({ colony }) =>
{
  return colony.cass.totalInfluence;
};


const Value = styled(Text)`
  font-variant-numeric: tabular-nums;
`;


const Component = (props) =>
(
  <Flex align = 'center' gap = '1'>

    <Value size = '1' color = 'gray'>{getCurrent(props)}</Value>
    <Text.Note>→</Text.Note>
    <Value size = '1'>{getRemaining(props) + ' / ' + getTotal(props)}</Value>

  </Flex>
);


export default (props) =>
{
  return props.influenceDelta > 0 ? <Component {...props} /> : <Value size = '1'>{getCurrent(props) + ' / ' + getTotal(props)}</Value>;
};
